<ng-container *ngIf="multi;else templateSingle">
    <p-multiSelect [options]="groupedOptions| async"
                   [(ngModel)]="shopId"
                   group="true"
                   [styleClass]="styleClass"
                   (ngModelChange)="changed($event)"
                   placeholder="Select Shop"
                   selectedItemsLabel="{0} items selected">
    </p-multiSelect>
</ng-container>

<ng-template #templateSingle>
    <p-dropdown [options]="groupedOptions | async"
                [filter]="true"
                [(ngModel)]="shopId"
                [showClear]="true"
                [styleClass]="styleClass"
                (ngModelChange)="changed($event)"
                group="true"
                placeholder="Select Shop">
    </p-dropdown>
</ng-template>

<ng-template let-group pTemplate="group">
    <div class="text-center">
        <span class="text-primary">-- {{ group.label }} --</span>
    </div>
</ng-template>
